import { AllocationBase } from '../../accounting/abstract/allocation-base.model';

export class SalesInvoiceItemAllocation extends AllocationBase {

    static override CLASS_NAME: string = 'SalesInvoiceItemAllocation';

}
